module.exports = __webpack_public_path__ + "static/gray_right_rounded-a47e301f8400af4205d9e47b67479cd6.png";